/**
 * Lane FRONT-UI: the front screens' "where am I" row (บัญชี › เซิร์ฟเวอร์ › ตัวละคร) shown at the top of each card,
 * and the keyboard helpers the cards share (arrow keys between choices, Esc for the back button).
 */
import { h } from '../ui/dom';

const STEPS = ['บัญชี', 'เซิร์ฟเวอร์', 'ตัวละคร'] as const;

/** The step row; `at` is the screen's step (0 login, 1 servers, 2 select / create). */
export function frontSteps(at: number): HTMLElement {
  const row = h('ol', { class: 'fr-steps' });
  row.setAttribute('aria-label', 'ขั้นตอน');
  STEPS.forEach((label, i) => {
    const li = h('li', { class: i < at ? 'done' : i === at ? 'on' : '' }, h('i', {}, String(i + 1)), label);
    if (i === at) li.setAttribute('aria-current', 'step');
    row.append(li);
  });
  return row;
}

/**
 * Up / Down (and Left / Right) move the focus between the enabled `sel` elements inside `box`, wrapping around;
 * Home / End jump to the ends. Text fields keep their own arrow keys.
 */
export function arrowNav(box: HTMLElement, sel: string): void {
  box.addEventListener('keydown', (e) => {
    const k = e.key;
    if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(k)) return;
    if (e.target instanceof HTMLInputElement) return;
    const items = [...box.querySelectorAll<HTMLElement>(sel)].filter(
      (x) => !(x as HTMLButtonElement).disabled && x.offsetParent !== null,
    );
    if (!items.length) return;
    const i = items.indexOf(document.activeElement as HTMLElement);
    const n = items.length;
    const j =
      k === 'Home' ? 0 : k === 'End' ? n - 1 : k === 'ArrowUp' || k === 'ArrowLeft' ? (i - 1 + n) % n : (i + 1) % n;
    items[i < 0 ? 0 : j]!.focus();
    e.preventDefault();
  });
}

/** Esc presses the screen's back button (not while the lofi station's listen mode has the screen). */
export function escBack(screen: HTMLElement, back: () => void): void {
  screen.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || document.documentElement.classList.contains('lofi-listen')) return;
    e.preventDefault();
    back();
  });
}
